module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }